/**
 * Cache compartilhado de /cart.js para os scripts do tema que consultam o
 * estado do carrinho de forma independente (free-shipping, cart-checkbox-upsell).
 * Evita fetches duplicados na mesma carga de pagina.
 * Invalida no evento 'cartUpdated' ja disparado por assets/cart.js.
 */
window.CartState = (function () {
  var cachedPromise = null;

  function fetchCart() {
    cachedPromise = fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .catch(function (error) {
        cachedPromise = null;
        throw error;
      });
    return cachedPromise;
  }

  document.addEventListener('cartUpdated', function () {
    cachedPromise = null;
  });

  return {
    get: function () {
      return cachedPromise || fetchCart();
    },
    invalidate: function () {
      cachedPromise = null;
    }
  };
})();
